// This function is to test whether a variable is null, undefined or an ampty string.
export const isEmpty = (val: any): boolean => val === undefined || val == null || val.length <= 0;

export const preciseFloat = (n: number, precision: number = 1) =>
  Math.round(n * Math.pow(10, precision)) / Math.pow(10, precision);
